import { __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { ListItem } from '../ListItem/ListItem.js';
import { SearchListItemWrapper, MarkingWrapper, Marking, ToolTip, ListItemWrapper, PriceTagWrapper, ButtonWrapper, MaxWrapper } from './SearchListItem.styles.js';
import { PriceTag } from '../PriceTag/PriceTag.js';
import { EPriceVariant, EPriceSize } from '../PriceTag/PriceTag.types.js';

var SearchListItem = function SearchListItem(_a) {
  var _b;

  var button = _a.button,
      fallBackImage = _a.fallBackImage,
      item = _a.item,
      _c = _a.loading,
      loading = _c === void 0 ? false : _c,
      markings = _a.markings,
      priceTag = _a.priceTag,
      _d = _a.showMax,
      showMax = _d === void 0 ? false : _d;
  var showPriceStripe = ((_b = priceTag.multiPrice) !== null && _b !== void 0 ? _b : 0) > 1 && priceTag.variant === EPriceVariant.PRIO;
  return React.createElement(SearchListItemWrapper, null, markings && React.createElement(MarkingWrapper, null, markings === null || markings === void 0 ? void 0 : markings.map(function (marking, index) {
    return React.createElement(Marking, {
      key: index
    }, React.createElement(ToolTip, {
      backgroundColor: marking === null || marking === void 0 ? void 0 : marking.backgroundColor,
      left: (index + 1) * 25
    }, marking.tooltipText), marking.image);
  })), React.createElement(ListItemWrapper, null, React.createElement(ListItem, {
    fallBackImage: fallBackImage,
    item: item,
    loading: loading,
    showPriceStripe: showPriceStripe
  })), React.createElement(PriceTagWrapper, null, React.createElement(PriceTag, __assign({}, priceTag, {
    size: EPriceSize.SMALL
  }))), React.createElement(ButtonWrapper, null, React.createElement(MaxWrapper, {
    showMax: showMax
  }, "Max antal uppn\xE5tt"), button));
};

export { SearchListItem };